import APIService from '.';
import { IchangeStatusData } from './FlagServiceTypes';

export interface IFlagUpdate {
  status: string;
  iosVersion?: string | null;
  androidVersion?: string | null;
  groups: {
    id?: string;
    name: string;
    customers: string[];
    businesses: string[];
  }[];
}

export default class FlagsService extends APIService {
  getFlags() {
    return this.get('/super-admin/feature-flag');
  }

  paginateFlags(query: Record<string, string> | string) {
    return this.get(`/super-admin/feature-flag?${this.getQueryString(query)}`);
  }

  changeStatus(flagId: string, body: IFlagUpdate) {
    return this.put(`/super-admin/feature-flag/${flagId}`, body);
  }

  createFlagDownloadUrl(body: { name: string; slug: string }) {
    const url = new URL(`${this.host()}/super-admin/feature-flag/download`);

    url.searchParams.append('slug', body.slug);
    url.searchParams.append('name', body.name);

    return url.toString();
  }

  getAllFlagsForAllEnvs() {
    return this.axios.get('https://ff.internal.twism.info/flags', {
      withCredentials: false,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
      }
    });
  }

  refreshAllFlagsForAllEnvs() {
    return this.axios.get('https://ff.internal.twism.info/refresh-flags', {
      withCredentials: false,
      headers: {
        'Access-Control-Allow-Origin': '*',
        'Content-Type': 'application/json'
      }
    });
  }
}
